import { Box, Tab, Tabs } from '@mui/material';
import { matchPath, NavLink, useLocation } from 'react-router-dom';
import { LinkItem } from './LinkItem';

interface Props {
  readonly links: readonly LinkItem[];
}

export function NavLinksMUI(p: Props) {
  const location = useLocation();

  const activeTabIndex = p.links.findIndex((link) => {
    if (link.isActive) {
      return link.isActive(matchPath(link.to, location.pathname), location);
    }
    return link.exact ? location.pathname === link.to : location.pathname.startsWith(link.to);
  });

  return (
    <Tabs
      value={activeTabIndex >= 0 ? activeTabIndex : 0}
      onChange={() => {
        // noop
      }}
      aria-label="navigation tabs"
      sx={{
        mt: -0.5,
        '& .MuiTabs-indicator': {
          backgroundColor: 'primary.main',
        },
      }}
      variant="scrollable"
      scrollButtons="auto"
    >
      {p.links.map((link, index) => (
        <Tab
          key={link.to}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {link.icon} {link.text}
            </Box>
          }
          component={NavLink}
          disabled={link.disabled}
          to={link.to}
          value={index}
          sx={{
            fontWeight: 500,
            textTransform: 'uppercase',
            minHeight: '48px',
            '&:hover': {
              color: 'text.primary',
            },
            '&.Mui-selected': {
              color: 'primary.main',
            },
          }}
        />
      ))}
    </Tabs>
  );
}
